export const SET_ACTIVATE_SCENARIO = 'ACTIVATE_SCENARIO';
export const NEW_SCENARIO = 'NEW_SCENARIO';

export const FETCH_SCENARIOS = 'FETCH_SCENARIOS';
